/**
 * Template variable definitions shown in the template editor.
 *
 * Variables use {{key}} syntax, e.g. {{driver.first_name}}, {{car.make}}, {{today}}, and
 * are resolved server side by messaging/template_variables.py. Resolution walks the
 * driver/agreement/car objects dynamically, so paths beyond the ones listed here work
 * too - {{driver.balance}}, {{agreement.car.car_model.name}}, {{driver.branch.name}}.
 */

export const TEMPLATE_VARIABLES = [
  // Driver
  { key: 'driver.first_name', label: 'First name', category: 'Driver', example: 'John' },
  { key: 'driver.last_name', label: 'Last name', category: 'Driver', example: 'Smith' },
  { key: 'driver.name', label: 'Full name', category: 'Driver', example: 'John Smith' },
  { key: 'driver.email', label: 'Email', category: 'Driver', example: 'john@example.com' },
  { key: 'driver.phone', label: 'Phone', category: 'Driver', example: '+1 555-000-0000' },
  // Agreement
  { key: 'agreement.start_date', label: 'Start date', category: 'Agreement', example: 'Jan 1, 2025' },
  { key: 'agreement.end_date', label: 'End date', category: 'Agreement', example: 'Jun 1, 2025' },
  { key: 'agreement.base_charge', label: 'Weekly base charge', category: 'Agreement', example: '300' },
  { key: 'agreement.deposit', label: 'Deposit', category: 'Agreement', example: '500' },
  // Car
  { key: 'car.year', label: 'Year', category: 'Car', example: '2022' },
  { key: 'car.make', label: 'Make', category: 'Car', example: 'Toyota' },
  { key: 'car.model', label: 'Model', category: 'Car', example: 'Camry' },
  { key: 'car.color', label: 'Color', category: 'Car', example: 'Black' },
  { key: 'car.vin', label: 'VIN', category: 'Car', example: '1HGBH41JXMN109186' },
  { key: 'car.plate', label: 'Plate', category: 'Car', example: 'ABC1234' },
  // System
  { key: 'today', label: "Today's date", category: 'System', example: 'Mar 30, 2025' },
  { key: 'now', label: 'Current date & time', category: 'System', example: 'Mar 30, 2025 2:00 PM' },
]
